const M = [
  {
    name: "singleTransfer",
    zh: "单笔转账",
    en: "Single transaction"
  },
  {
    name: "batchTransfer",
    zh: "批量转账",
    en: "Bulk fund transfer"
  },
  {
    name: "batchTransferRecord",
    zh: "批量转账记录",
    en: "Bulk fund transfer history"
  },
  {
    name: "theOtherAccount",
    zh: "对方账户",
    en: "The other account"
  },
  {
    name: "eAccountPhone",
    zh: "易付宝账号/手机号",
    en: "eepay account/ phone number"
  },
  {
    name: "transferTips",
    zh: "注：钱将实时转入对方账户，无法退款",
    en:
      "Note: The money will be transferred to the other account in real time and cannot be refunded"
  },
  {
    name: "enterTransferAccountOrPhone",
    zh: "请输入转入方账号或手机号",
    en: "Enter the transfer-in account or mobile number"
  },
  {
    name: "transferPersonal",
    zh: "转账给个人账号",
    en: "Transfer to personal account"
  },
  {
    name: "addNote20",
    zh: "添加备注（20字以内）",
    en: "Add notes (within 20 words)"
  },
  {
    name: "confirmTransfer",
    zh: "确认转账",
    en: "Confirm"
  },
  {
    name: "transferAmount",
    zh: "转账金额",
    en: "Transfer amount"
  },
  {
    name: "addTransferGroup",
    zh: "添加转账组",
    en: "Add transfer group"
  },
  {
    name: "immediatelyTransfer",
    zh: "立即转账",
    en: "Immediately transfer"
  },
  {
    name: "setTransferGroupName",
    zh: "设置转账组名称",
    en: "Set transfer group name"
  },
  {
    name: "enterTransferGroupName",
    zh: "请输入转账组名称",
    en: "Enter transfer group name"
  },
  {
    name: "memberList",
    zh: "成员列表",
    en: "Member list"
  },
  {
    name: "addTeamMembers",
    zh: "添加组员",
    en: "Add member"
  },
  {
    name: "addTransferObject",
    zh: "添加转账对象",
    en: "Add account/Mobile number"
  },
  {
    name: "query",
    zh: "查询",
    en: "Query"
  },
  {
    name: "delTeamMembers",
    zh: "删除组员",
    en: "Delete member"
  },
  {
    name: "toTransfer",
    zh: "去转账",
    en: "Transfer"
  },
  {
    name: "modifyName",
    zh: "修改名称",
    en: "Modify name"
  },
  {
    name: "delTransferGroup",
    zh: "删除该转账组",
    en: "Delete transfer group"
  },
  {
    name: "sureDelete",
    zh: "确定删除吗？",
    en: "Are you sure to delete it?"
  },
  {
    name: "added",
    zh: "已添加",
    en: "Added"
  },
  {
    name: "continueAdd",
    zh: "继续添加",
    en: "Continue to add"
  },
  {
    name: "total",
    zh: "总计：",
    en: "Total:"
  },
  {
    name: "haveAddedUser",
    zh: "您已添加了该用户",
    en: "Account added already"
  },
  {
    name: "pleaseAddTransferObject",
    zh: "请添加转账对象",
    en: "Add account/Mobile number"
  },
  {
    name: "transferDesc",
    zh: "转账说明",
    en: "Transfer description"
  },
  {
    name: "wantDeleteMessage",
    zh: "是否要删除该条信息？",
    en: "Do you want to delete this message?"
  },
  {
    name: "total",
    zh: "合计",
    en: "Total"
  },
  {
    name: "wrongNumberTransferTips",
    zh: "含有错误号码或重复号码,是否继续转账？",
    en: "Wrong number or repetitive number,Do you want to continue to transfer?"
  },
  {
    name: "accountMobileTransfer",
    zh: "导入账号、手机号、转账金额",
    en: "Import account, mobile number, transfer amount"
  },
  {
    name: "importExcelLimitTips",
    zh: "您可以将您在excel创建好的信息导入进行批量转账(单次最多导入1000条)",
    en:
      "You can import the information you have created in Excel for batch transfer (up to 1000 items can be imported at a time)"
  },
  {
    name: "incompleteInformation",
    zh: "信息不完整",
    en: "Incomplete information"
  },
  {
    name: "accountMobileAmountEditTips",
    zh: "表格中的账号、手机号、转账金额均可点击编辑",
    en:
      "Click to edit the account number, mobile phone number, and transfer amount in the form"
  }
];

export default M;
